import Swal from "sweetalert2";
import { IEmpresas } from "../interfaces/IEmpresas";
import api from "./Api";

class ImportarService {

  async enviarArquivoObrigacaoAcessoria(esteira: number, urlArquivo: string, nomeArquivo: string, textoPopupSucesso?: string): Promise<boolean> {
    try {
      await api.post(`ObrigacaoAcessoria/Importar/${esteira}`, {
        urlArquivo,
        nomeArquivo
      });

      textoPopupSucesso && Swal.fire({
        text: textoPopupSucesso,
        timer: 3000,
        icon: 'success',
        showConfirmButton: false
      });

      return true;
    } catch (error: any) {
      Swal.fire({
        text: error.message,
        timer: 4000,
        icon: 'error',
        showConfirmButton: false
      });
      return false;
    }
  }

  async enviarArquivoExtrato(esteira: number, conta: number, urlArquivo: string, nomeArquivo: string, textoPopupSucesso?: string): Promise<boolean> {
    try {
      await api.post(`BancoCaixaImportacao/importar/${esteira}/${conta}`, {
        urlArquivo,
        nomeArquivo
      });

      textoPopupSucesso && Swal.fire({
        text: textoPopupSucesso,
        timer: 3000,
        icon: 'success',
        showConfirmButton: false
      });

      return true;
    } catch (error: any) {
      Swal.fire({
        text: error.message,
        timer: 4000,
        icon: 'error',
        showConfirmButton: false
      });
      return false;
    }
  }

  async enviarArquivo(regime: string, urlArquivo: string, nomeArquivo: string, funcaoSucesso?: (data: IEmpresas) => void, textoPopupSucesso?: string): Promise<boolean> {
    try {
      const { data: result } = await api.post<IEmpresas>(`Importacao/ecd/${regime}`, {
        urlArquivo,
        nomeArquivo
      });

      funcaoSucesso && funcaoSucesso(result);

      textoPopupSucesso && Swal.fire({
        text: textoPopupSucesso,
        timer: 3000,
        icon: 'success',
        showConfirmButton: false
      });

      return true;
    } catch (error: any) {
      Swal.fire({
        text: error.message,
        timer: 4000,
        icon: 'error',
        showConfirmButton: false
      });
      return false;
    }
  }

  async getBancosContas(esteiraID: number, funcaoSucesso?: (data: any[]) => void): Promise<boolean> {
    try {
      const { data: result } = await api.get<any[]>(`Importacao/bancos-contas/${esteiraID}`);
      funcaoSucesso && funcaoSucesso(result);
      return true;
    } catch (error: any) {
      return false;
    }
  }
}


export default new ImportarService();